import React, { useEffect, useRef } from 'react';

export default function AnimatedBackground() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let raf;
    let particles = [];

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      const count = Math.min(80, Math.floor((canvas.width * canvas.height) / 22000));
      particles = Array.from({ length: count }).map(() => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.25,
        vy: (Math.random() - 0.5) * 0.25,
        r: Math.random() * 1.8 + 0.4,
        a: Math.random() * 0.6 + 0.2,
      }));
    };
    resize();
    window.addEventListener('resize', resize);

    const tick = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      for (let i = 0; i < particles.length; i++) {
        for (let j = i + 1; j < particles.length; j++) {
          const p1 = particles[i], p2 = particles[j];
          const dx = p1.x - p2.x, dy = p1.y - p2.y;
          const d = Math.hypot(dx, dy);
          if (d < 120) {
            ctx.strokeStyle = `rgba(52,200,120,${0.07 * (1 - d / 120)})`;
            ctx.lineWidth = 0.6;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
          }
        }
      }
      
      particles.forEach(p => {
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0 || p.x > canvas.width) p.vx *= -1;
        if (p.y < 0 || p.y > canvas.height) p.vy *= -1;
        ctx.fillStyle = `rgba(52,200,120,${p.a * 0.55})`;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fill();
      });
      raf = requestAnimationFrame(tick);
    };
    tick();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (
    <div aria-hidden className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
      {}
      <div className="absolute inset-0 mesh-bg" />
      {}
      <div className="absolute -top-40 -left-32 w-[480px] h-[480px] rounded-full blur-[140px] opacity-25
                      bg-[radial-gradient(circle,#34c878_0%,transparent_70%)] animate-orb-drift" />
      <div className="absolute top-1/3 -right-40 w-[520px] h-[520px] rounded-full blur-[150px] opacity-18
                      bg-[radial-gradient(circle,#5ed4a2_0%,transparent_70%)] animate-orb-drift"
           style={{ animationDelay: '-6s' }} />
      <div className="absolute bottom-0 left-1/3 w-[420px] h-[420px] rounded-full blur-[140px] opacity-15
                      bg-[radial-gradient(circle,#27a77f_0%,transparent_70%)] animate-orb-drift"
           style={{ animationDelay: '-12s' }} />
      {}
      <div className="absolute inset-0 grid-bg opacity-40" />
      {}
      <canvas ref={canvasRef} className="absolute inset-0" />
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background/60" />
    </div>
  );
}
